import { render } from "./MonthPurchases.vue?vue&type=template&id=35dc4497&scoped=true"
import script from "./MonthPurchases.vue?vue&type=script&lang=js"
export * from "./MonthPurchases.vue?vue&type=script&lang=js"

import "./MonthPurchases.vue?vue&type=style&index=0&id=35dc4497&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dc4497"]])

export default __exports__